<div class="container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="36px">
  <div class="role-header" fxLayout fxLayoutAlign="space-between center">
    <div *ngIf="chosenRole" class="header" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="2px">
      <span class="title">{{chosenRole.name}}</span>
      <span class="description">{{'OFFBOARDING_SPEC_DESC' | translate}}</span>
    </div>

    <button mat-button (click)="openRequirementsChooseEditDialog()">
      <mat-icon>edit</mat-icon>
      {{'CHANGE_ROLE' | translate}}
    </button>
  </div>

  <div *ngIf="chosenRole" class="requirements-list">
    <ul>
      <li *ngFor="let action of chosenRole.actions">
        {{action}}
      </li>
    </ul>
  </div>
</div>
